import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import ApiHelper from "../../../../../Helpers/ApiHelper";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import { HelpDeskApiUrls } from "../../API/HelpDeskAPI";
import { generateAlert } from "../../../../../Helpers/AlertMessagesHelper";

const CreateNewRequest = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.user.token);
  const userRole = useSelector((state) => state.auth.user.userRole);
  const user = useSelector((state) => state.auth.user);

  const companyId = userRole === "User" ? null : user.companyUser?.company?.companyId || null;
  const companyUserId = userRole === "User" ? null : user.companyUser?.companyUserId || null;

  const [title, setTitle] = useState();
  const [subject, setSubject] = useState();
  const [image, setImage] = useState();
  const [previewImage, setPreviewImage] = useState();

  const submitRequest = (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append("CompanyUserId", companyUserId);
    formData.append("CompanyId", companyId);

    formData.append("Title", title);
    formData.append("Subject", subject);

    if (image) {
      formData.append("Image", image);
    }

    ApiHelper.xmlPostFormData(HelpDeskApiUrls.createHelpRequest, formData, token, (res) => {
      alert(JSON.parse(res.response).message);
      if (JSON.parse(res.response).statusCode === 1) {
        generateAlert("success", "İşlem Başarılı");
      } else {
        generateAlert("danger", "Bir Hata oluştu");
      }
    });
  };

  return (
    <div>
      <Form onSubmit={submitRequest}>
        <Row className={"mx-0"}>
          <Col xs={12} md={8} xxl={7}>
            <Form.Control
              placeholder={t("helpTitle")}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            ></Form.Control>
          </Col>
          <Col xs={12} className={"mt-3"}>
            <Form.Control
              placeholder={t("helpSubject")}
              as={"textarea"}
              style={{ minHeight: 250 }}
              onChange={(e) => {
                setSubject(e.target.value);
              }}
            ></Form.Control>
          </Col>

          <Col xs={12} className={" align-content-center"}>
            <Row>
              <Col xs={"auto"} className={"align-content-center"}>
                {t("addAHelpingImage")}:
              </Col>
              <Col className={"align-content-center"}>
                <Row>
                  {previewImage && (
                    <Col xs={"auto"}>
                      <img height={70} alt={"Company Logo"} src={previewImage} />
                    </Col>
                  )}

                  <Col className={"align-content-center"} xs={"auto"}>
                    <label className="admin-setting-page-add-image-label justify-content-start">
                      <input
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setImage(file);
                            setPreviewImage(URL.createObjectURL(file));
                          } else {
                            // Reset state if no file is selected
                            setImage(null);
                            setPreviewImage(null);
                          }
                        }}
                        type="file"
                        accept=".jpeg, .png, .webp, .jpg"
                      />
                    </label>
                  </Col>
                </Row>
              </Col>
              <Col xs={"auto"} className={"ms-auto my-3"}>
                <Button
                  disabled={!subject || !title}
                  type="submit"
                  className="button primary"
                  style={{ height: "50px", width: "200px" }}
                >
                  {t("submit")}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
export default CreateNewRequest;
